// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/61f79bee85650dd6cad8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"399d77b0b019f865cfef","139":"abe9dc3423463401291d","140":"0056fb46eb306f5fba49"}[chunkId] + ".chunk.js";
};